import React from 'react';

interface IProps {
  message?: string;
}

const AuthError: React.FC<IProps> = ({ message = 'Missing required authentication' }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
      <h1
        style={{
          color: '#9B1C2E',
          fontSize: '1.25rem',
          fontWeight: 900
        }}>
        401 Authentication
      </h1>
      <h3
        style={{
          color: '#4B5563',
          fontSize: '1.125rem',
          fontWeight: 500
        }}>
        {message}
      </h3>
    </div>
  );
};

export default AuthError;
